import { withFormik } from 'formik';
import { compose, withState, branch, renderComponent } from 'recompose';
import PubSub from 'pubsub-js';

import ContactForm from './ContactForm';
import ContactFormSuccess from './ContactFormSuccess';

import {
  CONTACT_FORM_SUBMIT_SUCCESS,
  CONTACT_FORM_SUBMIT_ERROR
} from '../../../../client/GoogleAnalytics/events';

// eslint-disable-next-line
const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

const enhance = compose(
  withState('success', 'setSuccess', false),
  withFormik({
    mapPropsToValues: () => ({ name: '', email: '', message: '' }),
    validate: ({ email }) => {
      const errors = {};

      if (!emailRegex.test(email)) {
        errors.email = 'Email is invalid';
      }

      return errors;
    },
    handleSubmit: (
      values,
      { props: { setSuccess }, setSubmitting, setErrors }
    ) => {
      window.grecaptcha
        .execute(window.RECAPTCHA_KEY, { action: 'contact_form_submit' })
        .then(recaptchaToken =>
          fetch('/api/contact', {
            method: 'POST',
            body: JSON.stringify({ ...values, recaptchaToken }),
            headers: { 'Content-Type': 'application/json' }
          })
        )
        .then(res => {
          setSubmitting(false);

          if (!res.ok) {
            setSuccess(false);
            setErrors({ message: 'Something went wrong. Mind trying later?' });
            PubSub.publish(CONTACT_FORM_SUBMIT_ERROR);
            return;
          }

          PubSub.publish(CONTACT_FORM_SUBMIT_SUCCESS);

          setSuccess(true);
        });
    },
    displayName: 'ContactForm'
  }),
  branch(({ success }) => success, renderComponent(ContactFormSuccess))
);

export default enhance(ContactForm);
